export const localResources = {
    pl: {
        translation: {
            login: {
                loginText: "Zaloguj się",
                incorrectEmail: "Niepoprawny adres e-mail",
            },
            register: {
                passwordTooShort: "Hasło musi zawierać co najmniej 6 znaków",
                passwordsNotSame: "Hasła muszą być identyczne",
                accountAlreadyExists:
                    "Konto o takim adresie email już istnieje",
                createAccount: "Stwórz swoje konto",
                repeatPassword: "Powtórz hasło",
            },
            resetPassword: {
                resetPassword: "Zresetuj hasło",
                sendLink: "Wyślij link",
                resetPasswordHint:
                    "Podaj adres email konta, dla którego chcesz zresetować hasło",
                linkSent: "Link do resetu hasła został wysłany na e-mail",
            },
            changePassword: {
                changeOwnPassword: "Zmień swoje haasło",
                passwordIsSameAsLastOne:
                    "Nowe hasło musi różnić się od obecnego",
                passwordChanged: "Hasło zmieniono pomyślnie",
                invalidPassword: "Nieprawidłowe hasło",
                currentPassword: "Aktualne hasło",
                configNewPassword: "Potwierdź nowe hasło",
                newPassword: "Nowe hasło",
            },
            home: {
                codeUsed: "Kod został już wykorzystany lub jest nie prawidłowy",
                codeAccepted: "Kod zaakceptowany",
                enterCode: "Wpisz kod poniżej, aby dodać licencję",
                activateCode: "Aktywuj kod",
            },
            authentication: {
                wrongPassword: "Niepoprawne hasło",
                wrongEmail: "Użytkownik nie istnieje",
            },
            errors: {
                internal: "Coś poszło nie tak sprobuj ponownie poźniej",
            },
            labels: {
                email: "E-mail",
                emailExample: "np. some@email.com",
                password: "Hasło",
                passwordExample: "np. ********",
                codeExample: "np. SDK8D",
                logout: "Wyloguj się",
                goBack: "Cofnij",
                register: "Zarejestruj się",
                changePassword: "Zmień hasło",
                forgotPassword: "Zapomniałeś hasła?",
                payment: "Zakup licencję",
            },
        },
    },
    en: {
        translation: {
            login: {
                loginText: "Sign in",
                incorrectEmail: "Incorrect e-mail address",
            },
            register: {
                passwordsNotSame: "Passwords aren't the same",
                passwordTooShort: "Password must be at least 6 characters long",
                accountAlreadyExists:
                    "Account with this email assigned already exists",
                createAccount: "Create your account",
                repeatPassword: "Confirm your password",
            },
            resetPassword: {
                resetPassword: "Reset your password",
                sendLink: "Send link",
                resetPasswordHint:
                    "Enter the email address of the account for which you want to reset the password",
                linkSent:
                    "A link to reset the password has been sent to your e-mail",
            },
            changePassword: {
                changeOwnPassword: "Change own password",
                passwordIsSameAsLastOne:
                    "New password can't be the same as current password",
                passwordChanged: "Password changed successfully",
                invalidPassword: "Incorrect password",
                currentPassword: "Current password",
                configNewPassword: "Config new password",
                newPassword: "New password",
            },
            home: {
                codeUsed: "Code has already been used or is incorrect",
                codeAccepted: "Code accepted",
                enterCode: "Enter code below to add license",
                activateCode: "Activate the code",
            },
            authentication: {
                wrongPassword: "Incorrect password",
                wrongEmail: "User does not exist",
            },
            errors: {
                internal: "Something went wrong, please try again later",
            },
            labels: {
                email: "E-mail",
                emailExample: "e.g. some@email.com",
                password: "Password",
                passwordExample: "e.g. ********",
                codeExample: "e.g. SDK8D",
                logout: "Log out",
                goBack: "Go back",
                register: "Create an account",
                changePassword: "Change password",
                forgotPassword: "Forgot your password?",
                payment: "Purchase license",
            },
        },
    },
};

export default localResources;
